import { render, staticRenderFns } from "./MailSmtpForm.vue?vue&type=template&id=85165c78"
import script from "./MailSmtpForm.vue?vue&type=script&lang=js"
export * from "./MailSmtpForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports